export const styles = {
  tabIndicator: {
    backgroundColor: '#4D6EF5',
  },
  tablist: {
    width: '100%',
    height: '100%',
    minHeight: 'unset',
    '& .MuiTabs-indicator': {
      height: '2px',
      borderRadius: '2px 2px 0px 0px',
      color: '#4D6EF5',
    },
    '& .Mui-selected': {
      color: '#4D6EF5 !important',
    },
    '& .MuiTabs-flexContainer': {
      gap: '24px',
      position: 'absolute',
      bottom: '8px',
    },
  },
  tab: {
    minHeight: 'unset',
    padding: '0',
    paddingBottom: '8px',
    fontSize: '14px',
    lineHeight: '20.44px',
    fontWeight: 400,
    color: '#23252F',
    fontFamily: 'Inter, sans-serif !important',
    textTransform: 'none',
  },
};
